export const curaboxBaseConfig = {
  storyblok: {
    settingsPath: 'product-domains/curabox/settings/de',
    pagesPath: 'product-domains/curabox/www/de',
  },
  errorPage: 'curabox',
  redirects: 'curabox',
} as const

export const pflegeServicesBaseConfig = {
  path: '/services',
  storyblok: {
    settingsPath: 'product-domains/pflege-de-services/settings/de',
    pagesPath: 'product-domains/pflege-de-services/www/de',
  },
  errorPage: 'basic',
} as const
